import { useHeaderContext } from '@jouzen/ecom-components';
import { type ReactNode } from 'react';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import useDiscountMessage from '@/app/[locale]/product/_hooks/useDiscountMessage';

import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';

interface LayoutProps {
  readonly children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const {
    currentRoute,
    currentStep,
    isAccessory,
    isOuraRing4Wizard,
    itemCountForIcon,
  } = useWizardStateContext();
  const { displayMessage } = useDiscountMessage();
  const hasEyebrow = displayMessage !== null && !isAccessory;
  const headerContext = useHeaderContext();

  const inverseHeader = headerContext?.inverse;

  if (!currentRoute.isReady) return null;

  return (
    <>
      <DesktopLayout
        hasEyebrow={hasEyebrow}
        currentStep={currentStep}
        inverseHeader={inverseHeader}
        isAccessory={isAccessory}
        isOuraRing4Wizard={isOuraRing4Wizard}
        itemCountForIcon={itemCountForIcon}
      >
        {children}
      </DesktopLayout>
      <MobileLayout
        hasEyebrow={hasEyebrow}
        currentStep={currentStep}
        inverseHeader={inverseHeader}
        isAccessory={isAccessory}
        isOuraRing4Wizard={isOuraRing4Wizard}
        itemCountForIcon={itemCountForIcon}
      >
        {children}
      </MobileLayout>
    </>
  );
};

export default Layout;
